<div class="brn-table__pagination-settings">
  show
  <span *ngFor="let limit of limits; last as isLast">
    <b (click)="setLimit(limit)" [ngClass]="{ active: limit === currentLimit }">
      <b>{{ limit >= 10000 ? 'All': limit }}</b>
    </b>
    <i *ngIf="!isLast">/</i>
  </span>
  by page
</div>
